export const createError = e => {
	if (
		e &&
		e.hasOwnProperty('response') &&
		e.response &&
		e.response.hasOwnProperty('status')
	) {
		return { err: 'Ошибка', status: e.response.status }
	}
	return { err: 'Ошибка' }
}
